import { render, staticRenderFns } from "./PerformSetting.vue?vue&type=template&id=9d526066&"
import script from "./PerformSetting.vue?vue&type=script&lang=js&"
export * from "./PerformSetting.vue?vue&type=script&lang=js&"
import style0 from "./PerformSetting.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports